export default "__VITE_ASSET__BwCa2pho__"